import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import { Route, Redirect, withRouter, match } from "react-router";
import { observeResource } from "kea-resource";
import { createSelectorRx } from "keautils";

import { RepView } from "./form";

interface Props {
    match: match<{ id: string }>
}

/**Muestra un REP */
export class RepDetalle extends React.PureComponent<Props> {
    id = (x: Props) => Number.parseInt(x.match.params.id);
    value = createSelectorRx(this.id, id => observeResource(resources.Rep.Get, id));

    render() {
        return <RepView value={this.value(this.props)} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/reps/edit/index.tsx